import React from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ testId = "theme-toggle-button" }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  const isDark = theme === "dark";

  return (
    <button
      data-testid={testId}
      aria-label="Cambiar tema"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="relative w-10 h-10 rounded-xl border border-border bg-secondary/60 flex items-center justify-center text-foreground transition-colors hover:bg-accent"
    >
      {mounted && (
        <span className="transition-transform duration-300">
          {isDark ? <Moon className="w-[18px] h-[18px] text-emerald-400" /> : <Sun className="w-[18px] h-[18px] text-amber-500" />}
        </span>
      )}
    </button>
  );
}
